export default __webpack_public_path__ + "static/media/fr.ba5c48d9.svg";